import { CategoriesScreen } from '../features/catalog/CategoriesScreen'

export function CategoriesPage() {
  return <CategoriesScreen />
}
